import React, { useCallback, useMemo, useState } from 'react';
import { PayableAmount } from './PayableAmount';

export function SplitPaymentToggleContent(props) {
	const { cartData, coupon, addToCart } = props;

	const [selectedOption, setSelectedOption] = useState('none');

	const updateCart = useCallback(
		e => {
			let product = {
				download_id: 474227,
				price_id: e.target.value,
			};

			if (coupon?.is_valid) {
				product.discount = coupon.code;
			}

			addToCart(product, true, true);
		},
		[cartData, coupon]
	);

	const agencyLifetime = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return {
			index: cartData?.contents?.findIndex(item => +item.id === 474227),
			product: cartData?.contents?.find(item => +item.id === 474227),
		};
	}, [cartData]);

	const isSplitItemSelected = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return cartData?.details?.find(item => {
			return cartData?.splits?.find(splitItem => {
				return (
					+splitItem?.price_id ===
					+item?.item_number?.options?.price_id
				);
			});
		});
	}, [cartData]);

	return (
		<>
			<div className=" wp-checkout-split-payment-add">
				<ul className="wp-checkout-split-payment-item-list">
					{cartData?.splits?.map(option => (
						<li
							className="wp-checkout-split-payment-item"
							key={`radio-${option.price_id}`}
						>
							<input
								type="radio"
								name="splitPayment-item"
								id={`radio-${option.price_id}`}
								className="wp-checkout-checkbox-input"
								value={+option.price_id}
								checked={
									+agencyLifetime?.product?.options
										?.price_id === +option.price_id
								}
								onChange={updateCart}
							/>
							<label
								className="wp-checkout-checkbox-label splitPayment-add-checkbox"
								htmlFor={`radio-${option.price_id}`}
							></label>
							<label
								htmlFor={`radio-${option.price_id}`}
								className="wp-checkout-font-base split-payment-label"
							>
								{option.times} Months
							</label>
						</li>
					))}
				</ul>

				{isSplitItemSelected && (
					<PayableAmount product={isSplitItemSelected} />
				)}
			</div>
		</>
	);
}
